export var Segment;
(function (Segment) {
    /** Access database used in the Live site. */
    Segment["LIVE"] = "LIVE";
    /** Access staging (sandbox) database used in the editor. */
    Segment["SANDBOX"] = "SANDBOX";
    /** Access deleted database used in the Live site. */
    Segment["TRASH_LIVE"] = "TRASH_LIVE";
})(Segment || (Segment = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
//# sourceMappingURL=types.impl.js.map